import { render, staticRenderFns } from "./GreenCoffeeReviewModal.vue?vue&type=template&id=77545966&scoped=true"
import script from "./GreenCoffeeReviewModal.vue?vue&type=script&lang=js"
export * from "./GreenCoffeeReviewModal.vue?vue&type=script&lang=js"
import style0 from "./GreenCoffeeReviewModal.vue?vue&type=style&index=0&id=77545966&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77545966",
  null
  
)

export default component.exports